<template>
  <th
    @click="column.orderable !== false ? $emit('click', column) : null"
    :class="{ clickable: column.orderable !== false }"
  >
    {{ getNameForColumn(column) }}&nbsp;
    <i
      v-if="$route.query.order_by == column.key && column.orderable !== false"
      class="fas"
      :class="
        $route.query.order_direction == 'asc'
          ? 'fa-sort-amount-up-alt'
          : 'fa-sort-amount-down-alt'
      "
    ></i>
  </th>
</template>

<script>
export default {
  name: "th-orderable",
  props: ["column"],
  mounted() {},
  methods: {
    getNameForColumn(column) {
      if (Object.hasOwnProperty(column, "name")) {
        return column.name;
      }

      if (column.getName) {
        return column.getName();
      }
    }
  }
};
</script>
